import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import Axios from 'axios';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from '.';

export const ActionGrid = forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [actionFormInit, setPageFormInit] = useState(null);

    const fetchData = async () => {
        try {
            let dataResponse = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/actions`);
            return dataResponse.data;
        } catch (err) {
            console.log(err);
        }
    }

    const init = async () => {
        setLoading(true);
        let d = await fetchData();
        setData(d);
        setLoading(false);
    }

    const onFormSuccess = async (values) => {
        try {
            if (values.id) {
                let id = values.id;
                delete values.id;
                await Axios.patch(`${process.env.REACT_APP_API_BASE_URI}/api/actions/${id}`, values);
            } else {
                await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/actions`, values);
            }
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    const onDeleteItem = async (id) => {
        try {
            await Axios.delete(`${process.env.REACT_APP_API_BASE_URI}/api/actions/${id}`);
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        init();
    }, []);

    useImperativeHandle(ref, () => ({
        init: init,
        setPageFormInit: setPageFormInit,
    }));

    return (
        <>
            {props.showActions
                ? <Antd.Space
                    style={{
                        marginBottom: 10,
                        float: 'right',
                    }}
                >
                    <Antd.Button
                        icon={<AntdIcons.ReloadOutlined />}
                        title="Reload"
                        disabled={loading}
                        onClick={() => {
                            init();
                        }}
                    />
                    <Antd.Button
                        icon={<AntdIcons.PlusOutlined />}
                        title="Create new"
                        disabled={loading}
                        onClick={() => {
                            setPageFormInit({});
                        }}
                    />
                </Antd.Space>
                : null}
            <Antd.Table
                size={'small'}
                loading={loading}
                dataSource={data}
                rowKey={'id'}
                pagination={{
                    defaultPageSize: 50,                    
                    showSizeChanger: true,
                }}
            >
                <Antd.Table.Column
                    key='code'
                    dataIndex='code'
                    title='Code'
                    width={150}
                />
                <Antd.Table.Column
                    key='name'
                    dataIndex='name'
                    title='Name'
                    width={250}
                />
                <Antd.Table.Column
                    key='connector'
                    dataIndex='connector'
                    title='Connector'
                    width={100}
                />
                <Antd.Table.Column
                    key='action'
                    title='Action'
                    width={200}
                    render={(value, record) => (
                        <Antd.Space
                            size="middle"
                        >
                            <a
                                onClick={() => {
                                    record.decodedScript= atob(record.script);
                                    setPageFormInit(record);
                                }}
                            >
                                Edit
                            </a>
                            <a
                                onClick={() => {
                                    delete record.id;
                                    record.code = record.code + 'Copy';
                                    record.name = record.name + ' - copy';                                    
                                    onFormSuccess(record);
                                }}
                            >
                                Copy
                            </a>
                            <Antd.Popconfirm
                                placement="topLeft"
                                title="Do you really want to delete the entry?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    onDeleteItem(record.id);
                                }}
                            >
                                <a>
                                    Delete
                                </a>
                            </Antd.Popconfirm>
                        </Antd.Space>
                    )}
                />
            </Antd.Table>
            <Antd.Drawer
                title={actionFormInit && actionFormInit.id
                    ? 'Edit action'
                    : 'Create new action'}
                width={'85%'}
                visible={actionFormInit !== null
                    ? true
                    : false}
                closable={true}
                onClose={() => setPageFormInit(null)}
            >
                {actionFormInit
                    ? <SYS.ActionForm
                        initialValues={actionFormInit}
                        onSuccess={onFormSuccess}
                    />
                    : null}
            </Antd.Drawer>
        </>
    )
})